export default "__VITE_ASSET__121ebf53__"